import request from "@/utils/requestJSON";

export function getProductCategory() {
  return request({
    url: "/storage/Product/ProductCategory.json",
    method: "get",
  });
}

export function getProductDetail(JSON_NAME) {
  return request({
    url: "/storage/Product/" + JSON_NAME + ".json",
    method: "get",
  });
}

export function getCombinationList() {
  return request({
    url: "/storage/Product/CombinationList.json",
    method: "get",
  });
}
